import * as React from "react"
import chroma from "chroma-js"

import { ShirtHoody } from "./hoody"
import { ShirtShort } from "./short"
import { ShirtPolo } from "./polo"

const _Shirt = ({
  style,
  color,
  isEditor
}: {
  color: string
  style: string
  isEditor?: boolean
}) => {
  const secondColor = chroma(color).brighten(1).hex()
  switch (style) {
    case "hoody":
      return (
        <ShirtHoody
          color={color}
          lightColor={secondColor}
          isEditor={isEditor}
        />
      )
    case "polo":
      return (
        <ShirtPolo color={color} lightColor={secondColor} isEditor={isEditor} />
      )
    case "short":
    default:
      return <ShirtShort color={color} isEditor={isEditor} />
  }
}

export const Shirt = React.memo(_Shirt)
